import { okCircle, warning } from "@phonero/pux-icons/icons"
import { PuxIcon } from "@phonero/pux-react"
import css from "./HugeIcon.module.scss"

export const PuxHugeIcon = ({
  visible = true,
  state,
  ...rest
}: { visible?: boolean; state?: keyof typeof stateIcons } & Parameters<
  typeof PuxIcon
>[0]) => {
  const props = {
    ...(state && stateIcons[state]),
    ...rest,
  }

  return (
    <div className={css.hugeIcon}>
      {visible && <PuxIcon size="large" {...props} color={"primary"} />}
    </div>
  )
}

const stateIcons = {
  success: {
    icon: okCircle,
    className: css.success,
  },
  error: {
    icon: warning,
    className: css.error,
  },
  cancelled: {
    icon: warning,
    className: css.cancelled,
  },
  loading: {
    icon: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 38 38'%3E%3Cdefs%3E%3ClinearGradient id='a' x1='8.042%25' x2='65.682%25' y1='0%25' y2='23.865%25'%3E%3Cstop offset='0%25' stop-color='%23fff' stop-opacity='0'/%3E%3Cstop offset='63.146%25' stop-color='%23fff' stop-opacity='.631'/%3E%3Cstop offset='100%25' stop-color='%23fff'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd' transform='translate(1 1)'%3E%3Cpath stroke='currentColor' stroke-width='2' d='M36 18c0-9.94-8.06-18-18-18'%3E%3CanimateTransform attributeName='transform' dur='0.9s' from='0 18 18' repeatCount='indefinite' to='360 18 18' type='rotate'/%3E%3C/path%3E%3Ccircle cx='36' cy='18' r='1' fill='%23fff'%3E%3CanimateTransform attributeName='transform' dur='0.9s' from='0 18 18' repeatCount='indefinite' to='360 18 18' type='rotate'/%3E%3C/circle%3E%3C/g%3E%3C/svg%3E`,
    className: css.loading,
  },
}
